import { createContext, useState } from 'react'
import { getCache } from '../lib/cache'
import {
  getProjectByID,
  getUserRoleByID,
  getTownshipByID,
} from '../mock-data/roles'

const UserContext = createContext({
  eachData: {},
  setEachData: () => {},
  clearData: () => {},
  getUserInfo: () => {},
})

export function UserContextProvider(props) {
  const [user, setUser] = useState(
    getCache('userData') ? JSON.parse(getCache('userData')) : null
  )
  const context = {
    eachData: user,
    setEachData: (data) => {
      setUser(data)
    },
    clearData: () => {
      setUser({})
    },
    getUserInfo: () => {
      let info = `${user.username}`
      info += ` (${getUserRoleByID(user.role)?.name})`
      if (user.role == 4 || user.role == 2) {
        info += ` Of ${getProjectByID(user.project)?.name}`
      }
      if (user.role == 5) {
        info += `${getTownshipByID(user.township_group_id)?.name}`
      }
      return info
    },
  }
  return (
    <UserContext.Provider value={context}>
      {props.children}
    </UserContext.Provider>
  )
}

export default UserContext


